import React from "react";
import Card from 'react-bootstrap/Card';

const legendStyle = {
    position: "absolute",
    margin: "2rem",
    zIndex: 100,
    bottom: "44px",
    right: 0,

}
const legendSymbolStyle = {
    borderRadius: "50%",
    display: "inline-block",
    height: "10px",
    marginRight: "5px",
    width: "10px",
}
const legendSymbolColor = [
    {backgroundColor:'#F2F12D'},
    {backgroundColor:'#D5AE29'},
    {backgroundColor:'#B86B25'},
    {backgroundColor:'#954E23'},
    {backgroundColor:'#723122'},

]

/* get legend labels based on the result of jenks_breaks
* params: valueBreaks (for example: [1, 1, 2, 5, 11] --> Break values including min and max)
* output: e.g. [1, 2, '3-5', '6-11']
* */
const getLegendLabels = (valueBreaks) =>{
    let legend = [];
    // for the first legend label
    if (valueBreaks[0]===valueBreaks[1]){
        legend.push(valueBreaks[0])
    } else {
        legend.push(valueBreaks[0] + " - " + valueBreaks[1])
    }
    // for the 2nd+ labels
    for (let i = 1; i < valueBreaks.length - 1; i++ ){
        if (valueBreaks[i] - valueBreaks[i + 1] === -1){
            legend.push(valueBreaks[i + 1])
        } else{
            legend.push((valueBreaks[i] + 1) + " - " + valueBreaks[i + 1])
        }
    }
    // console.log(legend)
    return legend
}

const MapLegend = ({valueBreaksArr})=> {
    const legendLabels = getLegendLabels(valueBreaksArr);
    return (
        <Card style={legendStyle}>
            <Card.Body>
                <h6><b>Anzahl Pendler</b></h6>
                {
                    legendLabels.map((step, idx) => {
                        return <div key={idx}><span style={{...legendSymbolStyle, ...legendSymbolColor[idx]}}></span>{step}</div> })
                }
            </Card.Body>
        </Card>
    )
}

export default MapLegend;
